import { Component, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserProfileService } from '../../user-profile.service';
import Vs from '@app/services/validators/validators.service'
import {DatePipe} from "@angular/common";
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { isEmpty } from 'ramda';
import { Router } from '@angular/router';


@Component({
    selector: 'ltss-letters',
    templateUrl: './ltss-letters.component.html',
    styleUrls: ['./ltss-letters.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LtssLettersComponent {
    today: any = new Date();
    minimumDate = new Date("1900-01-01T00:00:00.000-06:00");
    search = new FormGroup({
        type: new FormControl('AL'),
        beginDate: new FormControl('', [Vs.required]),
        endDate: new FormControl('', [Vs.required])
    })
    beginDateError: any = { isError: false, errorMessage: '' };
    endDateError: any = { isError: false, errorMessage: '' };
    itemsEn = [{ code: 'AL', value: 'All' }, { code: 'ED', value: 'LTSS Eligibility' }, { code: 'AP', value: 'LTSS Appeal' }];
    itemsSp = [{ code: 'AL', value: 'Todos' }, { code: 'ED', value: 'LTSS Elegibilidad' }, { code: 'AP', value: 'LTSS Apelación' }];
    items;

    columns = [
        /*{ name: 'Letter Name', prop: 'letterName' },*/
        { name: 'Letter For', prop: 'letterFor' },
        { name: 'Date', prop: 'date' },
        { name: 'Letter Viewed?', prop: 'viewed' },
    ];
    isRmbRmc = false;
    allRows;
    rows;
    limit = 5;
    start = 1;
    end;
    linkMyCase = false;
    emptyMessage;
    emptyMessageEn = "No results for your search";
    emptyMessageSp = "No hay resultados para su búsqueda";
    translatedLang;
    indivId = sessionStorage.getItem('individualId');
    isAppealLetter: boolean = false;
    userType = sessionStorage.getItem('userType');
    isFromPartnerPortal = this.userType === 'RP' && !isEmpty(this.indivId);
    constructor(private userProfileService: UserProfileService, private datePipe: DatePipe,  public translateService: TranslateService,private titleService: Title, private router: Router) { 
    this.titleService.setTitle('My letters');
    }

    get f() {
        return this.search.controls;
    }

    ngAfterContentInit() {
        console.log("Myletters component");
        const defaultLanguage = this.translateService.getDefaultLang();
        this.translatedLang = defaultLanguage;
        if (defaultLanguage !== 'en') { 
            this.emptyMessage = this.emptyMessageSp;
            this.items = this.itemsSp;
        } else {
            this.emptyMessage = this.emptyMessageEn;
            this.items = this.itemsEn;
        }
        this.translateService.onDefaultLangChange.subscribe((res) => {
            this.translatedLang = res.lang;
            if (res.lang !== 'en') {
                this.emptyMessage = this.emptyMessageSp;
                this.items = this.itemsSp;
            } else {
                this.emptyMessage = this.emptyMessageEn;
                this.items = this.itemsEn;
            }
        });
        const indivId = sessionStorage.getItem('individualId');
        if (!indivId || indivId === '0' || indivId == 'undefined' || indivId == 'null') {
        this.linkMyCase = true;
        }
        const appealLetter = sessionStorage.getItem('appealLetter');
        if (appealLetter === 'true') {
          this.search.controls.type.patchValue("AP");
          sessionStorage.removeItem('appealLetter');
        }
        this.searchData()
    }

    setValidator() {
        if (this.f.beginDate.value) {
            this.search.get('endDate').setValidators([Vs.required, Vs.notBefore120Years])
        } else {
            this.search.get('endDate').clearValidators()
        }
    }

    searchData() {
        if (!this.allRows     || !this.allRows?.length     ) {
            this.fetchRowData()
        } else if (this.f.type.value === 'AL') {
        if(this.f.beginDate.value && !this.f.endDate.value){
            this.rows = this.allRows.filter( record => new Date(new Date(record.date)) >=  new Date(this.f.beginDate.value))
        } else if(this.f.endDate.value && !this.f.beginDate.value){
            this.rows = this.allRows.filter( record => new Date(record.date) <=  new Date(this.f.endDate.value))
        } else if(this.f.beginDate.value && this.f.endDate.value){
            this.rows = this.allRows.filter( record => ((new Date(record.date) >=  new Date(this.f.beginDate.value)) && (new Date(record.date) <=  new Date(this.f.endDate.value))))
        } else {
            this.rows =  this.allRows;
        }
    } else if (this.f.type.value === 'AP') {
        if(this.f.beginDate.value && !this.f.endDate.value){
            this.rows = this.allRows.filter( record => ((new Date(record.date) >=  new Date(this.f.beginDate.value)) && record.letterType === "APPEALS"))
        } else if(this.f.endDate.value && !this.f.beginDate.value){
            this.rows = this.allRows.filter( record => ((new Date(record.date) <=  new Date(this.f.endDate.value)) && record.letterType === "APPEALS"))
        } else if(this.f.beginDate.value && this.f.endDate.value){
            this.rows = this.allRows.filter( record => ((new Date(record.date) >=  new Date(this.f.beginDate.value)) && (new Date(record.date) <=  new Date(this.f.endDate.value)) && record.letterType === "APPEALS"))
        } else  {
        this.rows = this.allRows.filter( record => record.letterType === "APPEALS") 
        }
    } else if (this.f.type.value === 'ED') {
        if(this.f.beginDate.value && !this.f.endDate.value){
            this.rows = this.allRows.filter( record => ((new Date(record.date) >=  new Date(this.f.beginDate.value)) && record.letterType === "ELIGIBILITY"))
        } else if(this.f.endDate.value && !this.f.beginDate.value){
            this.rows = this.allRows.filter( record => ((new Date(record.date) <=  new Date(this.f.endDate.value)) && record.letterType === "ELIGIBILITY"))
        } else if(this.f.beginDate.value && this.f.endDate.value){
            this.rows = this.allRows.filter( record => ((new Date(record.date) >=  new Date(this.f.beginDate.value)) && (new Date(record.date) <=  new Date(this.f.endDate.value)) && record.letterType === "ELIGIBILITY"))
        } else  {
        this.rows = this.allRows.filter( record => record.letterType === "ELIGIBILITY")
        }
    }
    }


    findDiff( x, y ) { 
     const Difference_In_Time = y.getTime() - x.getTime();
     const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
     return Difference_In_Days <= 0 ? 0 : Difference_In_Days;
    };

    landed( value ) { 
     this.start = value.offset * this.limit + 1;
     this.end = this.rows.length < 5 ? this.rows.length : this.start - 1 + this.limit;
    }

    // 
     verifyTwoDates(event, from) {
        const date = event?.target?.value ? event?.target?.value : event ? event : null;
        
        // Add a small delay to ensure form control values are updated (especially for datepicker)
        setTimeout(() => {
            // Get current values after potential form update
            const beginDateValue = this.search.controls['beginDate'].value;
            const endDateValue = this.search.controls['endDate'].value;
            
            // Handle empty/cleared dates
            if ((!date || date === '') && from === 'beginDate' && !beginDateValue) {
                this.beginDateError = { isError: false, errorMessage: '' };
                this.endDateError = { isError: false, errorMessage: '' };
                return;
            }
            if ((!date || date === '') && from === 'endDate' && !endDateValue) {
                this.beginDateError = { isError: false, errorMessage: '' };
                this.endDateError = { isError: false, errorMessage: '' };
                return;
            }
            
            // Check if dates are valid before comparison
            const isBeginDateValid = this.isValidDate(beginDateValue);
            const isEndDateValid = this.isValidDate(endDateValue);
            
            // Only proceed with validation if both dates exist and are valid
            if (isBeginDateValid && isEndDateValid) {
                // Compare actual Date objects, not formatted strings
                const beginDate = new Date(beginDateValue);
                const endDate = new Date(endDateValue);
                
                // Check if begin date is after end date
                if(beginDate && endDate && beginDate > endDate) {
                    // Determine which field should show the error based on which was changed
                    if(from === 'beginDate') {
                        this.beginDateError = { isError: true, errorMessage: 'BEGIN_DATE_BEFORE_END_DATE' };
                        this.endDateError = { isError: false, errorMessage: '' };
                    } else {
                        this.endDateError = { isError: true, errorMessage: 'BEGIN_DATE_BEFORE_END_DATE' };
                        this.beginDateError = { isError: false, errorMessage: '' };
                    }
                } 
                // Check if dates are more than 12 months apart
                else if (this.monthDiff(beginDate, endDate) > 365) {
                    // Show error on the field that was changed
                    if(from === 'beginDate') {
                        this.beginDateError = { isError: true, errorMessage: 'INVALID_DATE_RANGE' };
                        this.endDateError = { isError: false, errorMessage: '' };
                    } else {
                        this.endDateError = { isError: true, errorMessage: 'INVALID_DATE_RANGE' };
                        this.beginDateError = { isError: false, errorMessage: '' };
                    }
                }
                else {
                    // Clear errors if dates are valid
                    this.beginDateError = { isError: false, errorMessage: '' };
                    this.endDateError = { isError: false, errorMessage: '' };
                }
            } else {
                // Clear errors if one or both dates are invalid/empty
                this.beginDateError = { isError: false, errorMessage: '' };
                this.endDateError = { isError: false, errorMessage: '' };
            }
        }, 0);
    };

     monthDiff(d1, d2) {
        const Difference_In_Time = d2.getTime() - d1.getTime();
        const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        return Difference_In_Days <= 0 ? 0 : Difference_In_Days;
    }

    PrintDoc ( docData ) { 
        const payload = {
            letterName: docData.letterName,
            letterFor: docData.memberName?.fullName,
            mailDate: this.datePipe.transform(docData.date, 'MM/dd/yyyy'),
            viewed: docData.letterViewedSw ? 'Yes' : 'No',
            letterType: docData.letterType,
            memberName: docData.memberName,
            indvNum: docData.indvNum,
            fileNetId: docData.fileNetDocId,
        };
        this.userProfileService.getPrintLTSSDocPdf(payload).subscribe((res: any) => {
            const file = new Blob([res], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
             this.fetchRowData();
        })
    };

    fetchRowData() {
        const indivIds = sessionStorage.getItem('indivIds') ? JSON.parse(sessionStorage.getItem('indivIds') || '{}').indivIds : [];
        this.userProfileService.getLTSSLetters({ indivIds }).subscribe((res: any) => {
            if (res && res.ltssLetters?.length) {
                const data = [...res.ltssLetters];
                this.allRows  = data.map(resp => {
                    const letter = resp
                    const pickDate = letter.mailDate.slice(0, 10);
                    const uploadDate = this.datePipe.transform(pickDate, "MMMM d, y");
                    return {
                        letterName: letter.letterName,
                        letterFor: letter.memberName?.fullName,
                        date: uploadDate,
                        viewed: letter.letterViewedSw ?  'Yes' : 'No',
                        letterType : letter.letterType,
                        memberName: letter.memberName,
                        indvNum: letter.indvNum,
                        fileNetDocId: letter.fileNetId,
                    }
                });
                this.rows = this.allRows;
                if (this.rows?.length && this.rows?.length > 1) {
                    this.rows.sort((a, b) => {
                        return new Date(b?.date).getTime() - new Date(a?.date).getTime();
                    });
                }
                this.end = this.rows.length < 5 ? this.rows.length : this.limit;
            } else {
                this.start = 0; 
                this.end = 0;
                this.rows = [];
            }
        });
    };

    getRows( record ) {
        return record.viewed === 'No' ? 'row-highlight' : '';
    };

    
    goToMyAppeals() {
        this.router.navigate(['/user-profile', 'my-appeals']);
    }

     /**
     * Helper method to check if a value is a valid date
     * @param value - The value to check
     * @returns true if the value is a valid date, false otherwise
     */
    private isValidDate(value: any): boolean {
        if (!value) return false;
        
        // Check if it's already a Date object
        if (value instanceof Date) {
            return !isNaN(value.getTime());
        }
        
        // Check if it's a string that represents a valid date
        if (typeof value === 'string') {
            // Reject obviously invalid date strings
            if (value.toLowerCase().includes('invalid')) {
                return false;
            }
            
            const date = new Date(value);
            return !isNaN(date.getTime());
        }
        
        return false;
    }

}